import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { StringRequest } from "../../../siteadmin/school-type-setup/shared/StringRequest";
import { DataService_ExcuseSetup } from "../shared/data.service";
import { ExcuseUpdateRequest } from "../shared/ExcuseUpdateRequest";

@Component({
	selector: "app-admin-setup-edit-excuse",
	templateUrl: "./admin-setup-edit-excuse.component.html",
	styleUrls: ["./admin-setup-edit-excuse.component.css"],
})
export class AdminSetupEditExcuseComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private adminSetupService: DataService_ExcuseSetup
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;

		//Get selected Excuse
		this.SelectedExcuse = this.dialogConfig.data.SelectedExcuse;

		//Update Form
		this.ExcuseID = this.SelectedExcuse.ExcuseID;

		//Check for code and Desc
		this.Code = this.SelectedExcuse.ExcuseCD;
		this.OriginalCode = this.SelectedExcuse.ExcuseCD;

		this.Desc = this.SelectedExcuse.ExcuseDesc;
		this.OriginalDesc = this.SelectedExcuse.ExcuseDesc;

		this.Excused = this.SelectedExcuse.IsExcusedInd == "Excused" ? true : false;
		this.CountPresent = this.SelectedExcuse.IsCountAsPresent == "Yes" ? true : false;

		this.AllSchools = this.SelectedExcuse.SchoolID <= 0 ? true : false;

		this.SchoolID = this.dialogConfig.data.SelectedSchool.SchoolID;
		this.SchoolName = this.dialogConfig.data.SelectedSchool.SchoolName;

		this.SchoolNameText = this.AllSchools == true ? "District" : this.SchoolName;
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	user: any;
	errorMessage: any = "";

	//Data from parent
	SelectedExcuse: any;
	ExcuseID: any;
	SchoolID: any;
	SchoolName: any;
	SchoolNameText: any;

	//Form Data
	Code: any = "";
	Desc: any = "";
	Excused: any = false;
	CountPresent: any = false;
	AllSchools: any = false;

	//Check for changes
	OriginalCode: any = "";
	OriginalDesc: any = "";

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		//Error handling
		if (this.Code == "") {
			this.errorMessage = "Enter an excuse code";
			return;
		}

		if (this.Desc == "") {
			this.errorMessage = "Enter an excuse name or Description";
			return;
		}

		if (String(this.Code) != String(this.OriginalCode)) {
			this.CheckCode();
		} else if (String(this.Desc) != String(this.OriginalDesc)) {
			this.CheckDesc();
		} else {
			this.FinishUpdate();
		}
	}

	CheckCode() {
		let parms: StringRequest = {
			str: this.Code,
		};

		var result = this.adminSetupService.ExcuseCodeInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Excuse Code already in use";
					return;
				} else {
					if (String(this.Desc) != String(this.OriginalDesc)) {
						this.CheckDesc();
					} else {
						this.FinishUpdate();
					}
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.Desc,
		};

		var result = this.adminSetupService.ExcuseDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Excuse Description already in use";
					return;
				} else {
					this.FinishUpdate();
				}
			},
			(error) => {}
		);
	}

	FinishUpdate() {
		// var DefinedBy: any = this.user.UserLevelID == 1 ? 4 : 3; ///////////
		var DefinedBy: any = this.SelectedExcuse.DefinedByID;

		var sID = this.SchoolID;
		if (this.AllSchools == true) {
			sID = -1;
		}

		let parms: ExcuseUpdateRequest = {
			ExcuseID: this.SelectedExcuse.ExcuseID,
			ExcuseCD: this.Code,
			ExcuseDESC: this.Desc,
			IsExcusedInd: this.Excused == true ? 1 : 0,
			DefinedByID: DefinedBy,
			SchoolID: sID,
			IsCountAsPresent: this.CountPresent == true ? 1 : 0,
		};

		var result = this.adminSetupService.ExcuseUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Excuse was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Excuse",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Events
	///////////////////////////////////////
	onAllChange(val) {
		this.AllSchools = val;

		if (this.AllSchools == true) {
			this.SchoolNameText = "District";
		} else {
			this.SchoolNameText = this.SchoolName;
		}
	}

	///////////////////////////////////////

	///////////////////////////////////////
	// Helpers
	///////////////////////////////////////

	UserNotDistrictLevel() {
		return this.user.UserLevelID != 1;
	}

	///////////////////////////////////////
}
